import {Component, EventEmitter, Inject} from '@angular/core';
import {CdkDragDrop, DragDropModule, moveItemInArray} from '@angular/cdk/drag-drop';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {FormsModule} from '@angular/forms';
import {UpperCasePipe} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatMenuModule} from "@angular/material/menu";
import {AppTableDisplayColumn} from "projects/nter-ui-kit/src/lib/webkit/components/crud-table/crud-table.model";

@Component({
  selector: 'app-crud-table-select-cols-dialog',
  standalone: true,
  imports: [
    DragDropModule,
    MatCheckboxModule,
    FormsModule,
    UpperCasePipe,
    MatIconModule,
    MatMenuModule,
  ],
  templateUrl: './crud-table-select-cols-dialog.component.html',
  styleUrls: ['./crud-table-select-cols-dialog.component.scss'],
})
export class CrudTableSelectColsDialogComponent {
  displayColumnsChange = new EventEmitter<AppTableDisplayColumn[]>();

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { displayColumns: AppTableDisplayColumn[] }
  ) {
  }

  drop(event: CdkDragDrop<any[]>) {
    moveItemInArray(
      this.data.displayColumns,
      event.previousIndex,
      event.currentIndex
    );
    this.displayColumnsChange.emit(this.data.displayColumns);
  }
}
